export enum ServiceProviderType {
  HotelService = 'hotel_service',
}

export interface CompanyServiceProvider {
  id: string;
  companyId: string;
  provider: ServiceProviderType;
  authKey: string;
}

export type NewServiceProvider = Pick<CompanyServiceProvider, 'provider' | 'authKey'>;
